<div class="content-stepper">
    <div class="content-stepper__body">
        <div class="container">
            <ng-content select="[body]"></ng-content>
        </div>
    </div>
</div>

